<script setup lang="ts">
import Button from "../buttons/Button.vue";

interface CardProps {
    title?: string;
    close?: boolean;
    cardPadding?: string;
}
defineProps<CardProps>();
const emit = defineEmits<(event: "close") => void>();
</script>
<template>
    <div class="card" :style="cardPadding ? { padding: cardPadding } : undefined">
        <div class="header" v-if="close || title">
            <h3 class="title" v-if="title">{{ title }}</h3>
            <Button v-if="close" class="close-btn" icon-only="x" type="neutral" variant="ghost" size="sm" @click="emit('close')" />
        </div>
        <slot></slot>
    </div>
</template>
<style scoped lang="scss">
.card {
    background-color: $white;
    @include regular-shadow-md;
    color: $text-main-900;
    border: 1px solid $stroke-soft-200;
    border-radius: 8px;
    padding: 20px;

    .header {
        display: flex;
        width: 100%;
        .title {
            @include font-size-16;
            font-weight: 500;
            margin-bottom: 16px;
        }
        .close-btn {
            margin-left: auto;
        }
    }
}
</style>
